import { graphql } from "@/lib/gql/__generated__/gql";

export const RoomCreateMutation = graphql(/* GraphQL */ `
	mutation RoomCreate($input: RoomInput!) {
		roomCreate(input: $input) {
			userErrors
			room {
				id
				hotelID
				roomID
				inSale
				isDormitoryType
				isShowStockPreview
				maxRoomNum
				capacityPeopleMaximum
				capacityAdultMaximum
				capacityKidsMaximum
				isKidsUnavailable
				kidsPolicy {
					kidsMaxAge
					kidsDiscountType
					ratio
					static {
						currencyType
						amount
					}
				}
				name
				catchCopy
				description
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				keyVisuals {
					bucket
					key
					region
					mimeType
					fileName
				}
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
				articleTitle
				saleTypeForPlan
				requiredPrepMillisecond
				amenities
				beds {
					bedType
					bedNum
				}
				roomSize
				overSiteControllerPeopleNum {
					prices {
						upperNum
						price {
							currencyType
							amount
						}
					}
					availableWeekDays
				}
				isExtendSiteControllerPeopleNum
				isNotDiscountTarget
				address {
					nationality
					postalCode
					state
					pref
					city
					town
					other
				}
				geoLocation {
					lat
					lon
				}
			}
		}
	}
`);
